<template>
  <b-table stacked="lg" :fields="fieldsItems" :items="items" class="text-center">
    <template v-slot:cell(action)="data">
      <span data-balloon-pos="up" data-balloon="مشاهده دوره">
        <router-link
          target="_blank"
          :to="'/courses/'+data.item.en_category +'/'+ data.item.en_subcategory +'/'+ (data.item.course_id || data.item.id) + '/' + data.item.course_title_en+'/list-content'"
          class="bttn-material-circle bttn-jelly bttn-md bttn-primary text-center"
          v-ripple
        >
          <i class="flaticon-eye"></i>
        </router-link>
      </span>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fieldsItems: [
        { key: "course_title", label: " نام دوره" },
        { key: "action", label: " عملیات" }
      ],
    }
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard-component/courses/my-enroll.vue